import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

// helpers
import { amountFormatter, prepEntityTypeLower, getItemWebUrl } from "/src/lib/helpers";

// amplitude
import AmplitudeHelperClass from '/src/lib/amplitudeHelper';
const amplitudeHelper = new AmplitudeHelperClass();

// constants
import { MAGNITT_ACCESS_ROLES } from '/src/lib/constants/userRoles';

// reusable
import { renderLockedGeneralSection } from '../../LockedContent';

// apis
import startupApi from '/src/apis/startupApi';
import investorApi from '/src/apis/investorApi';
import EstimationIndicator from '/src/components/Reusable/EstimationIndicator';



// reusable section for investor list, linked institutions list, startup relations list

export default class SimpleListSection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            title: "",

            // show more
            limit: 6,
            page: 1,
            count: 0,
            data: [],
            isLoading: false,
        }
    }

    componentDidMount = () => {
        const { user } = this.props;
        const hasAccess = (user && user.is_loggedin && (user.roles.includes(MAGNITT_ACCESS_ROLES.directory_access) || user.roles.includes(MAGNITT_ACCESS_ROLES.limited_directory_access)));
        this.setState({ hasAccess });
        this.prepTitle();
        if (hasAccess) {
            this.loadData();
        }
    }

    // detect if the component should re-render
    // this check is required for startup directory slider, to re-render this component when a new startup is selected
    componentDidUpdate = (prevProps) => {
        const { entityId } = this.props;
        const { hasAccess } = this.state;

        if ((entityId !== prevProps.entityId) && hasAccess) {
            this.prepTitle();
            this.setState({ data: [] }); // clear data of the previous entity
            this.loadData();
        }
    }

    loadData = async () => {

        let { limit, page } = this.state;
        const { entityId, entityType, dataType, isDirSlider } = this.props;

        let getData;
        if (dataType === "investor") {
            getData = startupApi.getInvestors;
        } else if (dataType === "linked-institution") {
            getData = startupApi.getInstitutions;
        } else if (dataType === "startup-relation") {
            getData = investorApi.getStartupRelations;
        }

        // reset limit to value passed from directory
        if (isDirSlider) {
            limit = this.props.limit;
        }

        await getData(entityId, entityType, limit, page).then(
            response => {
                return this.setState({
                    data: [...this.state.data, ...response.records],
                    count: response.totalRecords,
                    isLoading: false,
                })
            }
        );
    }

    prepTitle = () => {
        const { dataType } = this.props;
        let title = "";
        if (dataType === "investor") {
            title = "Investors";
        } else if (dataType === "linked-institution") {
            title = "Linked Institutions";
        } else if (dataType === "startup-relation") {
            title = 'Startup Relations';
        }
        this.setState({ title });
    }

    // amplitude
    amplitudeTrack = () => {
        const { dataType } = this.props;
        let action = "";
        if (dataType === "investor") {
            action = 'Investor Block Click to Profile';
        } else if (dataType === "linked-institution") {
            action = 'Linked Institution Clicked to Company Profile';
        } else if (dataType === "startup-relation") {
            action = 'Startup Relations Block Click to Profile';
        }

        if (action) {
            amplitudeHelper.trackEvent(action);
        }
    }

    handleShowMore = () => {
        const { limit, page, count } = this.state;
        let tempPage = (parseInt(page, 10));

        // Only increment the page if records exists
        if (count > (limit * tempPage)) {
            this.setState({ isLoading: true });
            tempPage = page + 1;
            this.setState({ page: tempPage },
                () => { this.loadData(); }
            );
        }
    }

    render() {

        const { dataType, entityType, isDirSlider, owner } = this.props;
        const { title, count, isLoading, data, hasAccess } = this.state;
        const showingCount = data ? data.length : 0;

        if (!hasAccess && dataType !== "linked-institution" && !isDirSlider && !owner) {
            const isPremiumLock = true;
            const lockType = dataType.replace("-", ' ') + "s";
            return (renderLockedGeneralSection(entityType, lockType, isPremiumLock, this.props.setState, title));
        }

        // no data
        if (data.length < 1) {
            return null;
        }

        return (
            <>
                {isDirSlider && <hr />}
                <div className="block team simple-detail-section">

                    <div className="title d-flex">
                        <h2>{title}</h2>
                        {(count > showingCount) &&
                            <span>{`(Showing ${showingCount} out of ${count})`}</span>
                        }
                    </div>

                    {dataType === "investor" && <EstimationIndicator />}

                    <div className="row">
                        {data && data.length > 0 &&
                            data.map((item, index) => {

                                // use the same parameter name since child keys are the same
                                if (dataType === "linked-institution") {
                                    item.entity_data = item.linked_data ? item.linked_data : {};
                                } else if (dataType === "startup-relation") {
                                    item.entity_data = item.startup_data ? item.startup_data : {};
                                    item.entity_data.type = "startup";
                                }

                                // skip empty/invalid data values
                                if (isEmpty(item.entity_data)) {
                                    return;
                                }

                                let path = "";
                                if (!isEmpty(item.entity_data)) {
                                    const entity = item.entity_data;
                                    const entityType = prepEntityTypeLower(entity.type);

                                    if (entityType.toLowerCase() === 'people') {
                                        path = undefined;
                                    } else {
                                        path = getItemWebUrl(entityType, entity.id, entity.code);
                                    }
                                    path = path && `/${path}`;
                                }

                                let containerClass = "col-6 col-md-4 entity-container";
                                let target_type = "";
                                if (isDirSlider) {
                                    containerClass = "col item-in-slider entity-container";
                                    target_type = "_blank";
                                }

                                // get primary industry
                                if (dataType === "startup-relation" && item.industry_data && item.industry_data.length > 0) {
                                    item.primary_industry = item.industry_data.filter((industry) => industry.is_primary)
                                }

                                return (
                                    <a key={dataType + "_" + index}
                                        className={containerClass}
                                        onClick={() => this.amplitudeTrack()}
                                        href={path}
                                        target={path && target_type}
                                        rel={path && "noopener noreferrer"}
                                    >
                                        <div className="row">
                                            <div className="col-3 col-sm-4 mt-0">
                                                <div className="simple-detail-img">
                                                    {(item.entity_data && item.entity_data.logo) ?
                                                        <img src={item.entity_data.logo} />
                                                        :
                                                        <div>{item.entity_data && item.entity_data.name?.charAt(0)}</div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-8 simple-detail-text">

                                                <p>{item.entity_data.name}</p>

                                                {dataType === "investor" &&
                                                    <>
                                                        <p>
                                                            {item.invested_amount > 0 ? `${amountFormatter(item.invested_amount)} - ` : ``}
                                                            {/* !isEmpty(item.funding_stage_data)
                                                                ? (item.funding_stage_data.is_proxy
                                                                    ? <span className="amount--estimated">{item.funding_stage_data.name}</span>
                                                                    : item.funding_stage_data.name)
                                                                : 'Undisclosed Round' */}
                                                            {item.funding_stage_data?.name || 'Undisclosed'}
                                                        </p>
                                                        <p>{moment(item.date_raised).format("MMM YYYY")}</p>
                                                    </>
                                                }

                                                {dataType === "linked-institution" &&
                                                    <p>{item.linked_data.type.charAt(0) + item.linked_data.type.slice(1).toLowerCase()}</p>
                                                }

                                                {dataType === "startup-relation" &&
                                                    <p>{item.primary_industry && item.primary_industry.length > 0 ?
                                                        item.primary_industry[0].name : ""
                                                    }</p>
                                                }

                                            </div>
                                        </div>
                                    </a>
                                )
                            })}
                    </div>

                    {/* show more button */}
                    {((data.length < count) && !isDirSlider) &&
                        <div className="d-flex justify-content-center mt-4 mb-0" onClick={this.handleShowMore}>
                            <a className="btn btn-main btn-sm">
                                {isLoading ?
                                    <i className="fas fa-circle-notch fa-spin mr-2"></i>
                                    :
                                    <i className="fas fa-arrow-circle-down mr-2"></i>
                                }
                                Show More
                            </a>
                        </div>
                    }

                </div>
            </>
        )
    }

}

